import { Directive, EventEmitter, Inject, Injector } from '@angular/core';
import { FicScreenConfig, FicScreenRef } from './fic-screen-injecotors';
import { IFicScreenConfig } from './fic-screen';
import { FicScreenRefBeforeCloseEvent, FicScreenRefModel } from './fic-screen-ref';

@Directive()
export abstract class FicScreenContentBase<TData, TRes = void> {
    get data(): TData {
        return this.config.data;
    }

    constructor(
        @Inject(FicScreenConfig) private config: IFicScreenConfig<TData, TRes>,
        @Inject(FicScreenRef) private screenRef: FicScreenRefModel<FicScreenContentBase<TData, TRes>, TRes>,
        protected injector: Injector,
    ) {}

    closeScreen(result?: TRes) {
        this.screenRef.close(result);
    }

    get beforeCloseScreen(): EventEmitter<FicScreenRefBeforeCloseEvent> {
        return this.screenRef.beforeClose;
    }
}
